// import pages
import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";
import { initializeOpenAPI } from "./api/core/OpenAPI";

import App from "./App";

import "../sass/style.scss";

// Initialize OpenAPI with runtime config
initializeOpenAPI();

// Setup Sentry similarly, reading from global appConfig
Sentry.init({
  dsn: (window as any).appConfig?.SENTRY_DSN || "",
  release: (window as any).appConfig?.COMMIT_SHA || "",
});

const container = document.getElementById("react-app");
if (!container) {
  throw new Error("React root container not found");
}
const root = createRoot(container);
root.render(<App />);
